import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/setting_table'
import SettingService from '../../network/services/setting'
import { serialize } from '../../network/request'
import SettingTable from './SettingTable'

const SettingPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Setting
    </Button>
  )

  return (
    <PageHeader title="All Settings" extra={[primaryAction]}>
      <Card>
        <SettingTableWrapper />
      </Card>
    </PageHeader>
  )
}

const SettingTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(SettingService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  console.log(response)

  if (!response) {
    return <Spin />
  }

  const { total } = SettingService.toPaginate(response)

  return (
    <>
      <SettingTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <SettingTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default SettingPage
